import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormikProvider, useFormik } from "formik";
import {
  OcCard,
  OcCardButtonBar,
  OcConfirmationDialog,
  OcSettingSwitchFormik,
} from "oc/components";
import { useOcProperty } from "oc/hooks";
import { useOcFormikHelper } from "oc/utils";
import { Box } from "@mui/material";

interface MyHrSettingsPayrollCardProps {
  isMobile: boolean;
}

export const MyHrSettingsPayrollCard = ({
  isMobile,
}: MyHrSettingsPayrollCardProps) => {
  const { t } = useTranslation();

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const { data: payrollMenuEnabledValue, loading: payrollMenuEnabledLoading } = useOcProperty({
    resource: "system",
    key: "payrollMenuEnabled",
    fetchPolicy: "network-only",
  });

  const formik = useFormik({
    initialValues: {
      payrollMenuEnabled: payrollMenuEnabledValue === "true",
    },
    onSubmit: () => {
      updateProperties();
    },
    enableReinitialize: true,
  });

  const { loadingState, updateProperties } = useOcFormikHelper({
    defaultResource: "system",
    formik,
    valuesExtraData: {
      payrollMenuEnabled: {
        key: "payrollMenuEnabled",
        loading: payrollMenuEnabledLoading,
        type: "switch",
        returnType: "boolean",
      },
    },
  });

  const handleSave = () => {
    setShowConfirmDialog(false);
    formik.submitForm();
  };

  const handleCancel = () => {
    formik.resetForm();
  };

  const handleDialogCancel = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <OcConfirmationDialog
        showDialog={showConfirmDialog}
        onClose={handleSave}
        onCancel={handleDialogCancel}
        title={t("OC_CONFIRM_SETTING")}
        texts={[t("OC_CONFIRM_SETTING_INFO")]}
        okButtonText={t("OC_ALL_RIGHT")}
        cancelButtonText={t("OC_CANCEL")}
      />
      <OcCard label={t("MY_HR_PAYROLL")} loading={loadingState}>
        <FormikProvider value={formik}>
          <Box height={8} />
          <OcSettingSwitchFormik
            name="payrollMenuEnabled"
            id="enabledPayrollMenu"
            label={t("MY_HR_PAYROLL")}
            info={t("MY_HR_PAYROLL_MENU_INFO")}
            isMobile={isMobile}
            disabled={loadingState}
          />
          <OcCardButtonBar
            handleRightButton={handleCancel}
            rightButtonColor="secondary"
            rightButtonText={t("OC_CANCEL")}
            handlePrimaryButton={() => setShowConfirmDialog(true)}
            primaryButtonText={t("OC_SAVE")}
            primaryButtonDisabled={loadingState || !formik.dirty}
          />
        </FormikProvider>
      </OcCard>
    </>
  );
};

export default MyHrSettingsPayrollCard;
